import { Component, Input , Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'sa-input-radio',
  templateUrl: './sa-input-radio.component.html',
  styleUrls: ['./sa-input-radio.component.css']
})
export class SaInputRadioComponent {
  @Input() selectedType = "";
  @Input() types:any = [];  
  @Input() title = "";
  @Output() selectedTypeChange = new EventEmitter<string>();

  change(){
    this.selectedTypeChange.emit(this.selectedType);
  }
}
